<div *ngIf="!decisionMode" [class]="tag.matchSearch ? 'feTagMatch' : 'feTag'" [class.leadMode]="leadMode"
     [innerHTML]="sanitizer.bypassSecurityTrustHtml(Utils.getHighlightedText(tag.label, keywords))">
</div>
<div *ngIf="decisionMode" class="decisionMode" [class.feTag]="!tag.matchSearch" [class.feTagMatch]="tag.matchSearch">
    <fe-icon [iconType]="IconType.decision_admin" [color]="ColorType.blue" [size]="12"/>
    <span [innerHTML]="sanitizer.bypassSecurityTrustHtml(Utils.getHighlightedText(tag.label, keywords))"></span>
</div>
